export type {
  AppointmentCompletionRequirementKey,
  AppointmentCompletionRequirementOverride,
  AppointmentCompletionRequirementOverrideMap,
  AppointmentCompletionRulesOverride,
  AppointmentDetailTabKey,
  AppointmentTypeAwareWorkItem,
  AppointmentTypeRulesConfig,
  ConfigurableTypeOption,
} from '@/lib/work-items/appointmentTypeConfig';

export {
  PURCHASE_APPOINTMENT_TYPE_KEY,
  appointmentTypeHasRequirement,
  appointmentTypeAllowsCompletionRequirementOverride,
  appointmentCompletionRequirementIsOverridden,
  appointmentCompletionRulesAreOverridden,
  isInheritedParentJobCompletionOverrideReason,
  appointmentTypeHidesTab,
  getAppointmentCompletionRequirementOverride,
  getAppointmentCompletionRequirementOverrides,
  getAppointmentCompletionRequirementKeys,
  getAppointmentCompletionRulesOverride,
  getAppointmentTypeKey,
  getAppointmentTypeOption,
  getAppointmentTypeRules,
  getDefaultAppointmentTypeRules,
  getHiddenAppointmentTabs,
  getOverridableAppointmentCompletionRequirementKeys,
  isPurchaseAppointment,
  normalizeAppointmentTypeKey,
  normalizeAppointmentTypeRules,
  shouldRequireAppointmentPublicClosingComment,
} from '@/lib/work-items/appointmentTypeConfig';
